module.exports = __webpack_public_path__ + "img/Etape 1 - 1.067103df.png";